export function isNonNumericOrSymbol(value) {
    return /^[^±!@£$%^&*_+§¡€#¢§¶•ªº«»"[\]\\/<>?:;|=(),0-9]+$/.test(value);
}
